import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

// Helper function to generate random colors
const getRandomVibrantColor = () => {
  const vibrantLetters = '89ABCDEF'; // Focus on high-intensity colors for vibrance
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += vibrantLetters[Math.floor(Math.random() * vibrantLetters.length)];
  }
  return color;
};


const ToolsUsageChart = ({ toolsArr }) => {
  // Apply sorting logic and map over toolsArr
  const processedData = toolsArr
    .sort((a, b) => {
      const percentageA = Number(a[1]) || 0; // Convert percentage to number or use 0 if NaN
      const percentageB = Number(b[1]) || 0; // Convert percentage to number or use 0 if NaN
      return percentageB - percentageA; // Sort in descending order
    })
    .map(([tool, percentage]) => ({
      tool: tool.replaceAll('-', ' ') === 'google search' ? 'google serp' : tool.replaceAll('-', ' '),
      usage: isNaN(Number(percentage)) ? 0 : parseFloat(percentage).toFixed(2), // Ensure fixed to 2 decimal places
    }));

  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart
        data={processedData}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 80, // Increased bottom margin for x-axis labels
        }}
        style={{ fontFamily: 'Quicksand', color: 'white' }} // Set font family and color
      >
        <CartesianGrid strokeDasharray="3 3" />
        {/* <XAxis 
          dataKey="tool" 
          tick={{ angle: -45, textAnchor: 'end', fill: 'white' }} // Rotating labels for better fit, white color
          interval={0} // Ensures all labels are rendered
        /> */}
        <YAxis 
          label={{ value: "Usage (%)", angle: -90, position: "insideLeft", fill: 'white' }} 
          tick={{ fill: 'white' }} // White axis text
        />
        <Tooltip 
          formatter={(value, name, props) => [`${value}%`, `${props.payload.tool}`]} // Custom tooltip with % and tool name
          contentStyle={{ fontFamily: 'Quicksand' }} // Tooltip font
        />
        <Bar
          dataKey="usage"
          barSize={40} // Adjust bar size if needed
        >
          {processedData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={getRandomVibrantColor()} /> // Assign a random color to each bar
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ToolsUsageChart;
